import { ThemeProvider } from '@emotion/react';
import { Grid, Stack, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { createTheme, styled } from '@mui/material/styles';
import Hr from 'components/atoms/Line/HorizontalLine';
import * as React from 'react';
import "./style.css"

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontSize: 10,
    fontFamily: ['lato'].join(','),
  },
});

const MainGrid = styled(Grid)(({ theme }) => ({
  padding: '5rem 8rem',
  [theme.breakpoints.down('md')]: {
    padding: '2rem',
  },
}));

const ParaText = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#e5e5e5',
}));

const GlobalFooter = () => {
  const logo = require('assets/logo.png');
  const facebookIcon = require('assets/icons/facebook.svg');
  const twitterIcon = require('assets/icons/twitter.svg');
  const instagramIcon = require('assets/icons/instagram.svg');
  const massengerIcon = require('assets/icons/massenger.svg');

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <AppBar
          position="relative"
          color="primary"
          sx={{
            background: '#13121a',
          }}
        >
          <MainGrid container>
            <Grid item xs={12} md={9} style={{ flexDirection: 'column' }} className = 'footerDiv'  >
              <div style={{ marginBottom: '2rem' }}>
                <img src={logo} alt="Main Logo" height={50} />
              </div>
              <div>
                <ParaText style={{ maxWidth: '350px' }}>
                  The world’s first and largest digital marketplace for crypto
                  collectibles and non-fungible tokens (NFTs). Buy, sell, and
                  discover exclusive digital items.
                </ParaText>
              </div>
            </Grid>
            <Grid item xs={12} md={3} style={{ flexDirection: 'column'}} className = 'footerDiv'>
              <ParaText>About</ParaText>
              <ParaText>Press</ParaText>
              <ParaText>Career</ParaText>
              <ParaText>Help</ParaText>
            </Grid>
          </MainGrid>

          <Grid
            container
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Hr style={{ maxWidth: '90%' }} />
          </Grid>

          <MainGrid
            container
            style={{ paddingTop: '2rem', paddingBottom: '4rem' }}
          >
            <Grid item xs={12} md={9} className = 'footerDiv'>
              <ParaText>Terms of service</ParaText>
            </Grid>
            <Grid item xs={12} md={3} className = 'footerDiv'>
              <Stack direction="row" spacing={2}>
                <img
                  src={facebookIcon.default}
                  alt="facebook Icon"
                  height={25}
                />
                <img
                  src={instagramIcon.default}
                  alt="instagram Icon"
                  height={25}
                />
                <img
                  src={massengerIcon.default}
                  alt="massenger Icon"
                  height={25}
                />
                <img src={twitterIcon.default} alt="twitter Icon" height={25} />
              </Stack>
            </Grid>
          </MainGrid>
        </AppBar>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default GlobalFooter;
